import dataService from "../helpers/dataService";

export const deleteCompany = (companyId) => {
  return new Promise((resolve, reject) => {
    dataService.remove(`clients/${companyId}`, {}, resolve, reject);
  });
};
